var map = {
	"./en/accountmanagement.json": 6556,
	"./en/addConnector.json": 33508,
	"./en/allMenus.json": 75862,
	"./en/amazons3.json": 40573,
	"./en/appComponents.json": 17045,
	"./en/autoupgrade.json": 50669,
	"./en/bxpAlerts.json": 11312,
	"./en/canvas.json": 3172,
	"./en/claimOrgAdmin.json": 48298,
	"./en/connectors.json": 65822,
	"./en/connectorsettings.json": 23759,
	"./en/credentials.json": 36775,
	"./en/currentConnector.json": 50563,
	"./en/dark.json": 80682,
	"./en/estate.json": 58466,
	"./en/featureManager.json": 14499,
	"./en/galleryComponents.json": 71609,
	"./en/galleryConfig.json": 57006,
	"./en/globalSearch.json": 3086,
	"./en/homePageDashboard.json": 20594,
	"./en/homepage.json": 87947,
	"./en/identityAccess.json": 14437,
	"./en/internal.json": 40850,
	"./en/leftNav.json": 14335,
	"./en/license.json": 16708,
	"./en/local.json": 69520,
	"./en/mfa.json": 8819,
	"./en/mfe.json": 20626,
	"./en/navMoved.json": 74856,
	"./en/notification.json": 84136,
	"./en/onPrem.json": 94170,
	"./en/playground.json": 73477,
	"./en/replication.json": 41004,
	"./en/splashScreen.json": 53983,
	"./en/spot.json": 76748,
	"./en/storage.json": 11195,
	"./en/support.json": 75791,
	"./en/timeline.json": 59292,
	"./en/utils.json": 93482,
	"./en/vendor.json": 77495,
	"./en/whatIsNewHomePage.json": 55441,
	"./en/whatsNew.json": 63870,
	"./en/workingenvironment.json": 33448,
	"./ja/accountmanagement.json": 6575,
	"./ja/addConnector.json": 42708,
	"./ja/allMenus.json": 26597,
	"./ja/amazons3.json": 94695,
	"./ja/appComponents.json": 99480,
	"./ja/autoupgrade.json": 95888,
	"./ja/bxpAlerts.json": 99816,
	"./ja/canvas.json": 29185,
	"./ja/claimOrgAdmin.json": 76593,
	"./ja/components.json": 99542,
	"./ja/connectors.json": 24082,
	"./ja/connectorsettings.json": 43177,
	"./ja/credentials.json": 20281,
	"./ja/currentConnector.json": 4412,
	"./ja/dark.json": 32569,
	"./ja/estate.json": 77943,
	"./ja/featureManager.json": 61906,
	"./ja/galleryComponents.json": 88560,
	"./ja/galleryConfig.json": 80376,
	"./ja/globalSearch.json": 57033,
	"./ja/homePageDashboard.json": 9422,
	"./ja/homepage.json": 11097,
	"./ja/identityAccess.json": 5947,
	"./ja/internal.json": 14503,
	"./ja/leftNav.json": 16518,
	"./ja/license.json": 56808,
	"./ja/local.json": 82001,
	"./ja/mfa.json": 68415,
	"./ja/mfe.json": 92599,
	"./ja/navMoved.json": 5282,
	"./ja/notification.json": 32748,
	"./ja/onPrem.json": 90110,
	"./ja/playground.json": 17926,
	"./ja/replication.json": 23680,
	"./ja/splashScreen.json": 75568,
	"./ja/spot.json": 42848,
	"./ja/storage.json": 64611,
	"./ja/support.json": 15932,
	"./ja/timeline.json": 98502,
	"./ja/utils.json": 43586,
	"./ja/vendor.json": 35133,
	"./ja/whatIsNewHomePage.json": 85269,
	"./ja/whatsNew.json": 15643,
	"./ja/workingenvironment.json": 7282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85189;